export enum UserRole
{
  VENDOR = 'vendor',
  DRIVER = 'delivery_partner',
  SUPER_ADMIN = 'super_admin',
  STAFF = 'staff',
}

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_ROLE: 'user_role',
  SUBSCRIPTION_ACTIVE: 'subscription_active',
  STAFF_PERMISSIONS: 'staff_permissions',
} as const;

/**
 * Maps staff permission keys to { route, label, icon/svgIcon }.
 * Used by MenuService to build the dynamic staff sidebar.
 */
export const PERMISSION_ROUTE_MAP: Record<string, { route: string; label: string; icon?: string; svgIcon?: string; childRoutes?: string[] }> = {
  dashboard:          { route: '/dashboard',             label: 'Dashboard',             icon: 'bi-graph-up' },
  vendors:            { route: '/vendors',               label: 'Vendors',               icon: 'bi-shop' },
  delivery_partners:  { route: '/delivery-partners',     label: 'Delivery Partners',     icon: 'bi-truck' },
  staff:              { route: '/staff',                  label: 'Staff Management',      icon: 'bi-people' },
  orders:             { route: '/total-orders',           label: 'Total Orders',          icon: 'bi-cart3' },
  ledger:             { route: '/ledger',                 label: 'Ledger',                icon: 'bi-journal-text' },
  submasters:         { route: '/subscription-masters',   label: 'Subscription Masters',  svgIcon: 'icons/award.svg' },
  approval_requests:  { route: '/approval-requests',      label: 'Approval Requests',     icon: 'bi-check-circle' },
  payout_dashboard:   { route: '/payout-dashboard',       label: 'Payout Dashboard',      svgIcon: 'icons/wallet2.svg', childRoutes: ['/payout-batches', '/payout-batch-detail', '/vendor-payout-detail'] },
  payout_batches:     { route: '/payout-batches',         label: 'Payout Batches',        svgIcon: 'icons/wallet2.svg' },
  payout_analytics:   { route: '/payout-analytics',       label: 'Payout Analytics',      svgIcon: 'icons/dashboard.svg' },
  payout_settings:    { route: '/payout-settings',        label: 'Payout Configuration',  icon: 'bi-gear' },
  fees_master:        { route: '/fees-master',             label: 'Fees Master',           icon: 'bi-currency-dollar' },
  analytics:          { route: '/analytics',              label: 'Analytics',             icon: 'bi-bar-chart-line' },
  expenses:           { route: '/add-expense',            label: 'Add Expense',           icon: 'bi-plus-circle' },
  gst:                { route: '/gst-management',         label: 'GST Management',        icon: 'bi-percent' },
};
